import { IAppState, TInlineAlert } from '../types/state.d';

import { createSelector } from 'reselect';

export const appSelector = (state: IAppState) => state.app;

export const getIsAnyCharityAllowed = createSelector(appSelector, (app) =>
  Boolean(app.yourFundraisingCause.allowAnyCharity),
);

export const getIsOwnEventAllowed = createSelector(appSelector, (app) =>
  Boolean(app.yourFundraisingCause.allowOwnEvent),
);

export const getIsInviteLinkCopied = createSelector(
  appSelector,
  (app) => app.isInviteLinkCopied,
);
export const getIsFatalError = createSelector(
  appSelector,
  (app) => app.isFatalError,
);

export const getInlineAlert = createSelector(
  appSelector,
  (app: IAppState['app']): TInlineAlert => app.inlineAlert,
);

export const getPageId = createSelector(appSelector, (app) => app.pageId);

export const getNewFrpData = createSelector(
  appSelector,
  (app) => app.newFrpData,
);

export const getSelectedEvent = (state: IAppState) =>
  appSelector(state).selectedEvent;

export const getSelectedCause = (state: IAppState) =>
  appSelector(state).selectedCause;
